import React from 'react';
import { ConfirmationModal, ItemCreationWrapper, ItemCreation } from '~/Components';

import { useLanguage } from '~/Hooks';
import { ICustomer } from './Customer.model';
import { useCustomerCreation } from './useCustomerCreation';
import { makeStyles } from '~/UIKit/Style';
import { DRAWER_INACTIVE_SELECTION, GRAY_USC, WHITE } from '~/Constants/Colors.constants';
import { Avatar } from '~/UIKit';
import { ImageUpload } from '../ImageUpload';
import { CameraOutline, Customer } from '~/Components/Icons';

const useStyles = makeStyles((theme) => ({
  itemContainer: {
    display: 'block',
    marginBottom: 60,

    "[class*='ItemCreationSubsectionInputContainer']": {
      marginBottom: 5,
    },

    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  imageUpload: {
    margin: '30px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  avatar: {
    position: 'relative',
    backgroundColor: DRAWER_INACTIVE_SELECTION,
    borderRadius: '50%',
    color: GRAY_USC,
  },
  uploadButton: {
    padding: 0,
    position: 'absolute',
    minWidth: 24,
    height: 24,
    borderRadius: '50%',
    bottom: 0,
    right: 0,
    backgroundColor: WHITE,

    svg: {
      width: 14,
      height: 16,
    },

    '&:hover': {
      backgroundColor: WHITE,
    },
  },
}));
interface CreateCustomerProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const CreateCustomer = ({ isOpen, setIsOpen }: CreateCustomerProps) => {
  const { t } = useLanguage();
  const { classes } = useStyles();

  const {
    onSave,
    initialValues,
    validate,
    isLoading,
    listItems,
    imageUrl,
    isSubmitDisabled,
  } = useCustomerCreation({
    setIsOpen,
  });

  return (
    <ConfirmationModal
      open={isOpen}
      title={t('app.customer.create')}
      cancel={{ action: () => setIsOpen(false) }}
      confirm={{ action: onSave, title: t('app.customer.create'), disabled: isSubmitDisabled }}
      rawContent
    >
      <div className={classes.itemContainer}>
        <div className={classes.imageUpload}>
          <div className={classes.avatar}>
            <Avatar size={88} className={classes.avatar} src={imageUrl}>
              <Customer />
            </Avatar>
            <ImageUpload
              className={classes.uploadButton}
              actionButtonIcon={<CameraOutline />}
              canvasStyle={{
                width: 300,
                height: 300,
                color: [0, 0, 0, 0.4],
                borderRadius: 500,
                border: 10,
              }}
            />
          </div>
        </div>
        <ItemCreationWrapper>
          <ItemCreation<ICustomer>
            listItems={listItems}
            headers={[]}
            onSave={onSave}
            initialValues={initialValues}
            validate={validate}
            isLoading={isLoading}
            networkError={undefined}
            validateOnMount
            disableMobile
            skipConfirmationModal
          />
        </ItemCreationWrapper>
      </div>
    </ConfirmationModal>
  );
};
